import HeaderLateral from "../../components/HeaderLateral";
import SelecionarPrecificador from "../../components/SelecionarPrecificador";
import './solicitarpedidos.css';
import api from '../../services/api';
import {IoClipboardOutline} from 'react-icons/io5';
import { useState ,useContext, useEffect} from "react";
import { AuthContext } from "../../contexts/auth";
import { useLoja } from "../../contexts/loja";
import { toast } from "react-toastify";
import {Helmet} from 'react-helmet';
import { SolicitarPedidosContext } from "../../contexts/solicitarPedidos";
import A3Horizontal from '../../files/A3-HORIZONTAL.pdf';
import A3Vertical from '../../files/A3-VERTICAL.pdf';

export default function SolicitarPedidos(){
    const {user,signOut} = useContext(AuthContext);
    const [cpf,setCpf] = useState('');
    const [obs,setObs] = useState('');
    const [formatoSelecionado,setFormatoSelecionado] = useState(0);
    const [campanhas,setCampanhas] = useState([]);
    const [campanhaSelecionada,setCampanhaSelecionada] = useState({});
    const [pedido,setPedido] = useState({});
    const {cpfMask,register,handleSubmit,errors, reset} = useContext(SolicitarPedidosContext);
    const [abriModal,setAbriModal] = useState(false);

    const { loja } = useLoja();
    
    const formatos = [
        { name: 'A4 Swift em dobro', id: 6, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))  },
        { name: 'Etiqueta Swift em dobro', id: 7, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))  },
        { name: 'Cavalete Swift em dobro', id: 8, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))  },
        { name: 'Etiqueta Swift Retangular', id: 11, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))  },
        { name: 'Etiqueta Rebaixa de preço', id: 12, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))  },
        { name: 'A3 Swift em dobro', id: 13, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))  },
        { name: 'Etiqueta Preço Progressivo', id: 14, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))  },
        { name: 'A4 Preço Progressivo', id: 15, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))  },
        { name: 'A3 Preço Progressivo', id: 16, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))  },
        { name: 'A4 Aniversário Dois Por menos', id: 17, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))  },
        { name: 'Etiquetas Aniversário Dois Por menos', id: 18, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))  },
        { name: 'A3 Aniversário Dois Por menos', id: 19, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))  },
        { name: 'A4 Aniversário Regular', id: 20, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))  },
        { name: 'A3 Aniversário Regular', id: 21, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))  },
        { name: 'Etiquetas Aniversário Regular', id: 22, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))  },
        { name: 'A4 Black friday Dois Por menos', id: 23, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))  },
        { name: 'A3 Black friday Dois Por menos', id: 24, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))  },
        { name: 'Etiquetas Black friday Dois Por menos', id: 25, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))  },
        { name: 'A4 Black friday Regular', id: 26, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))  },
        { name: 'A3 Black friday Regular', id: 27, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))  },
        { name: 'Etiquetas Black friday Regular', id: 28, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))  },
        { name: 'A5 oportunidade', id: 29, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))},
        { name: 'A5 Swift em dobro', id: 30, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))},
        { name: 'A5 Preco Progressivo', id: 31, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))},
        { name: 'A5 Regular', id: 32, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))},
        { name: 'A5 Rebaixa de Preço', id: 33, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))},
        { name: 'A4 Regular', id: 34, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))},
        { name: 'A4 Rebaixa De Preco', id: 35, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))},
        { name: 'Etiquetas Regular', id: 36, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))},
        { name: 'A5 Black Friday Regular', id: 39, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))},
        { name: 'A5 Black Friday Dois por menos', id: 40, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))},
        { name: 'A5 Aniversário Regular', id: 41, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))},
        { name: 'A5 Aniversário Dois por menos', id: 42, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))},
        { name: 'A4 Natal Regular', id: 43, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))},
        { name: 'A3 Natal Regular', id: 44, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))},
        { name: 'Etiquetas Natal Regular', id: 45, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))},
        { name: 'A4 Natal Dois Por Menos', id: 46, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))},
        { name: 'A3 Natal Dois Por Menos', id: 47, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))},
        { name: 'Etiquetas Natal Dois Por Menos', id: 48, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))},
        { name: 'A5 Natal Regular', id: 49, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))},
        { name: 'A5 Natal Dois Por Menos', id: 50, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))},
        { name: 'A4 oportunidade', id: 51, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))},
        { name: 'Etiquetas oportunidade', id: 52, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))},
        { name: 'A4 Natal (Apenas Texto) Regular', id: 53, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))},
        { name: 'A3 Natal (Apenas Texto) Regular', id: 54, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))},
        { name: 'Etiquetas Natal (Apenas Texto) Regular', id: 55, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))},
        { name: 'A4 Natal (Apenas Texto) Dois Por Menos', id: 56, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))},
        { name: 'A3 Natal (Apenas Texto) Dois Por Menos', id: 57, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))},
        { name: 'Etiquetas Natal (Apenas Texto) Dois Por Menos', id: 58, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))},
        { name: 'A5 Natal (Apenas Texto) Regular', id: 59, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))},
        { name: 'A5 Natal (Apenas Texto) Dois Por Menos', id: 60, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))},
        { name: 'A5 oportunidade (vencimento)', id: 61, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))},
        { name: 'A4 oportunidade (vencimento)', id: 62, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))},
        { name: 'Etiquetas oportunidade (vencimento)', id: 63, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))},
        { name: 'A4 Kit Completo', id: 64 },
        { name: 'Etiquetas Kit Completo', id: 65 },
        { name: 'A5 Kit Completo', id: 66 },
        { name: 'A3 Kit Completo', id: 67 },
        { name: 'A4 Kit Completo Natal', id: 68 },
        { name: 'Etiquetas Kit Completo Natal', id: 69 },
        { name: 'A5 Kit Completo Natal', id: 70 },
        { name: 'A3 Kit Completo Natal', id: 71 }]
    .filter((formato) => !formato.remover)
    
    const formatosSemCampanha = [
        { name: 'A4', id: 1 },
        { name: 'A3 Pedestal', id: 2, remover: loja.varejo === 'Fisica' },
        { name: 'A3 Cavalete', id: 3 },
        { name: 'Oportunidade A4', id: 4, remover: !(loja.varejo === 'Fisica' || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase())) },
        { name: 'Oportunidade Etiquetas', id: 5, remover: !(loja.varejo === 'Fisica' || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase())) },
        { name: 'A5 oportunidade', id: 38, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))},
        { name: 'A5 oportunidade (vencimento)', id: 61, remover: !(loja.varejo === 'Fisica' || loja.varejo === "X SUPER" || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase()))},
        { name: 'A4 oportunidade (vencimento)', id: 62, remover: !(loja.varejo === 'Fisica' || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase())) },
        { name: 'Etiquetas oportunidade (vencimento)', id: 63, remover: !(loja.varejo === 'Fisica' || ["BARBOSA","LOPES"].includes(loja.varejo.toUpperCase())) },
        { name: 'Só tem na Swift A4', id: 9 },
        { name: 'Só tem na Swift Etiquetas', id: 10 },
        { name: 'Só tem na Swift A5', id: 37 },
        { name: 'A5 regular', id: 33 },
        { name: 'A4 Kit Completo', id: 64, remover: loja.varejo === 'Fisica' },
        { name: 'Etiquetas Kit Completo', id: 65, remover: loja.varejo === 'Fisica' },
        { name: 'A5 Kit Completo', id: 66, remover: loja.varejo === 'Fisica' },
        { name: 'A3 Kit Completo', id: 67, remover: loja.varejo === 'Fisica' },
        { name: 'A4 Kit Completo Natal', id: 68, remover: loja.varejo === 'Fisica' },
        { name: 'Etiquetas Kit Completo Natal', id: 69, remover: loja.varejo === 'Fisica' },
        { name: 'A5 Kit Completo Natal', id: 70, remover: loja.varejo === 'Fisica' },
        { name: 'A3 Kit Completo Natal', id: 71, remover: loja.varejo === 'Fisica' },
    ].filter((formato) => !formato.remover)
    
    function adicionarItens(){
        if(pedido.id !== ''){
            setAbriModal(!abriModal)
        }else{
            toast.info('Nenhum pedido em andamento')
        }
    }

    //CRIA PEDIDO
    function criarPedido(data, e){
        const dadosProduto = {
            produto:"precificador",
            cpf:data.cpf,
            dataEntrega:"",
            tipoEntrega:loja.tipoEntrega,
            observacao:data.observacao,
            loja_id:loja.id,
            fornecedor_id:loja.fornecedorId,
            formato_id:data.formatoId,
            campanhaId:Number(data.campanhaId),
            usuario_id:user.id_usuario
        }
        api.post('/pedidos/pedidosweb',
            dadosProduto,
            {
                headers:{'Authorization':user.token}
            }
        ).then((resp)=>{
            getPedido(resp.data.pedidoId)
            setAbriModal(!abriModal)
            toast.success('Adicione os itens ao pedido.')
        }).catch((error)=>{
            if(error.response.status === 401){
                toast.info(error.response.data.error)
                signOut()
            }else{
                toast.error(error.response.data.error)
            }
        })
    }

    function buscarCampanhas(){
        if(loja.varejo === 'Fisica' || loja.varejo === "X SUPER"){
            api.get(`/campanhas?opcoesPedido&preco=${loja.preco}&loja=${loja.varejo}`,
                {
                    headers:{
                        'Authorization':user.token
                    }
                }
            )
            .then((resp)=>{
                setCampanhas(resp.data.campanhas)
            })
            .catch((error)=>{})
        }
    }

    const getPedido = (id) => {
        api.get(`/pedidos/${id}`,
            {
                headers:{'Authorization':user.token}
            }
        ).then((resp)=>{
            setPedido(resp.data.pedido[0])
        }).catch((error)=>{
            if(error.response.status === 401){
                toast.info(error.response.data.error)
                signOut()
            }else{
                toast.error(error.response.data.error)
            }
        })
    }
    
    useEffect(() => {
        buscarCampanhas()
        reset({formatoId: 0})
    }, [])

    return(
        <div className="solicitarcontainer">
            <Helmet>
                <meta charSet="utf-8"/>
                <title>Solicitar Pedido</title>
            </Helmet>
            <HeaderLateral/>
            <div className="solicitar-interno">
                <div className="solicitar-areacomponentes">
                    <div className="solicitar-header">
                        <IoClipboardOutline size={34}/>
                        <h3>Solicitar Pedido</h3>
                    </div>
                    <div className="pedido-cadastro">
                        <div className="form-container">
                            <form className="solicitar-pedidos-form" onSubmit={handleSubmit(criarPedido)}>
                                <div className="input-container">
                                    <h3>Identificação*</h3>
                                    <input  type="text" placeholder='Inserir cpf' value={cpf} {...register("cpf", {onChange: (e) => setCpf(cpfMask((e.target.value)))})}/>
                                    {errors.cpf && <p style={{ color:"red"}}>{errors.cpf?.message}</p>}
                                </div>

                                {(campanhas.length > 0) && (
                                    <div className="input-container">
                                        <h3>Campanha</h3>
                                        <select
                                            id='selCampanha'
                                            {...register("campanhaId", {
                                                onChange: (e) => {
                                                    setCampanhaSelecionada(campanhas.find((campanha) => campanha.id == e.target.value))
                                                    reset({formatoId: 0})
                                                }
                                            })}
                                        >
                                            <option key={0} value={0}>Selecionar</option>
                                            {campanhas.map((campanha)=> (
                                                <option key={campanha.id + "_campanha"} value={campanha.id}>{campanha.nome}</option>
                                            ))}
                                        </select>
                                    </div>
                                )}
                                <div className="input-container">
                                    <h3>Formato*</h3>
                                    <select
                                        id='selForm'
                                        {...register("formatoId", {
                                            onChange: (e) => setFormatoSelecionado(e.target.value)
                                        })}
                                    >
                                        <option key={0} value={0}>Selecionar</option>
                                        {
                                        campanhaSelecionada && campanhaSelecionada.id ?
                                        formatos
                                        .filter((formato) => !campanhaSelecionada?.id || campanhaSelecionada?.formatosId?.split(',')?.includes(String(formato.id)))
                                        .map((formato)=>(
                                            <option key={formato.id + "_formatos"} value={formato.id}>{formato.name}</option>
                                        )) :
                                            formatosSemCampanha.map((formato)=>(
                                                <option key={formato.id + "_formatos"} value={formato.id}>{formato.name}</option>
                                            ))

                                        }
                                    </select>
                                    {errors.formatoId && <p style={{ color:"red"}}>{errors.formatoId.message}</p>}
                                    {formatoSelecionado == 2 && <a href = {A3Vertical} target = "_blank">Baixar modelo</a>}
                                    {formatoSelecionado == 3 && <a href = {A3Horizontal} target = "_blank">Baixar modelo</a>}
                                </div>
                                <div className="input-container">
                                    <h3>Observação</h3>
                                    <input type="text" placeholder="Observação" value={obs} {...register("observacao", {onChange: (e)=> setObs(e.target.value)})}/>
                                    {errors.observacao && <p style={{ color:"red"}}>{errors.observacao.message}</p>}
                                </div>
                                <div className="button-container">
                                    <button className="actionSolicitar" type="submit">
                                        SOLICITAR
                                    </button>
                                    {/* <button type="button" className="actionSolicitar" onClick={adicionarItens}>
                                        (+) ITENS
                                    </button> */}
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            {(abriModal && !!pedido?.id) && (
                <SelecionarPrecificador
                    pedido={pedido}
                    formato={formatoSelecionado}
                    campanha={campanhaSelecionada}
                    fechar={()=>setAbriModal(!abriModal)}
                />
            )}
        </div>
    )
}